import { render } from "./ViewProjectBtn.vue?vue&type=template&id=790697a7"
import script from "./ViewProjectBtn.vue?vue&type=script&lang=js"
export * from "./ViewProjectBtn.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/arc-studio-front/arc-studio-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__